import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tab-panel',
  props: {
  height: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;



const screenSize = ref(screen.width);

const heightStyle = computed(() => {
  if (screenSize.value > 768)
    return props.height ? { height: props.height } : {};
  return "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(heightStyle.value),
    class: "tab-panel-container"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})